import { Text } from 'shared/ui/common/Text'
import { Button } from 'shared/ui/controls/Button'

import s from './NFCSMintExitConfirm.module.scss'

type Props = {
  onStay?: () => void
  onExit?: () => void
}

export function NFCSMintExitConfirm({ onStay, onExit }: Props) {
  return (
    <>
      <Text size={44} weight={700} isUppercased isCentered className={s.title}>
        Do you want
        <br />
        to quit the flow?
      </Text>

      <Text
        size={16}
        weight={600}
        isUppercased
        isCentered
        className={s.subtitle}
      >
        If you quit credit score generation flow,
        <br />
        you won’t be able to borrow. Are you sure?
      </Text>

      <Button
        size={72}
        fashion="secondary"
        isFullWidth
        onClick={onStay}
        className={s.stayBtn}
      >
        No, I want to finalise Credit Scoring flow
      </Button>
      <Button size={72} fashion="glass-matte" isFullWidth onClick={onExit}>
        Yes, I want to quit Credit Scoring flow
      </Button>
    </>
  )
}
